module.exports = __webpack_public_path__ + "img/squarelogo.c0f4cdd9.png";